import React from 'react';
import { useSelector } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '../../common/inputs/Button';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { Box, Grid } from '@mui/material';
import {
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LineIcon,
  LineShareButton,
  RedditIcon,
  RedditShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from 'react-share';
import EmailIcon from '@mui/icons-material/Email';
import ClipboardCopyTextField from '../../common/inputs/ClipboardCopyTextField';

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  color: theme.palette.primary.main,
  textAlign: 'center'
}));

const CenteredGridItem = styled(Grid)({
  textAlign: 'center'
});

const ShareDialog = ({ open, setOpen }) => {
  const { t } = useTranslation();
  
  // Use selector hooks instead of connect
  const registryUrl = useSelector(state => state.registry.url);
  
  const handleClose = () => {
    setOpen(false);
  };

  const url = registryUrl && ('https://' + registryUrl.Domain);

  return (
    <Dialog
      disableEnforceFocus
      open={open}
      aria-labelledby={t('share_title')}
      aria-describedby={t('share_title')}
    >
      <StyledDialogTitle>
        {t('share_title')}
      </StyledDialogTitle>
      <DialogContent>
        <Box py={2}>
          <Grid container spacing={3} justifyContent="center" alignContent="center">
            <CenteredGridItem xs={12}>
              {t('share_description')}
            </CenteredGridItem>
            <Grid item>
              <FacebookShareButton url={url}>
                <FacebookIcon size={48} round={true}/>
              </FacebookShareButton>
            </Grid>
            <Grid item>
              <TwitterShareButton url={url}>
                <TwitterIcon size={48} round={true}/>
              </TwitterShareButton>
            </Grid>
            <Grid item>
              <RedditShareButton url={url}>
                <RedditIcon size={48} round={true}/>
              </RedditShareButton>
            </Grid>
            <Grid item>
              <WhatsappShareButton url={url}>
                <WhatsappIcon size={48} round={true}/>
              </WhatsappShareButton>
            </Grid>
            <Grid item>
              <LineShareButton url={url}>
                <LineIcon size={48} round={true}/>
              </LineShareButton>
            </Grid>
            <Grid item>
              <EmailShareButton url={url}>
                <EmailIcon style={{ width: 48, height: 48, borderRadius: '50%', padding: 7, backgroundColor: '#7d7d7d' }} />
              </EmailShareButton>
            </Grid>

            <Grid item xs={12}>
              <ClipboardCopyTextField value={url} variant="outlined" fullWidth/>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="text" color="primary" onClick={handleClose}>
          {t('done_btn')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShareDialog;